import React, { Fragment, Component } from "react";
import Title from "./Title";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAllCompany } from "../../Graphs/Company/listCompany";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import SearchHeader from "../common/header-component/searchHeader";
import { Spin, notification } from "antd";
import CompanyRecordsTable from "./CompanyRecordsTable";
import { AddCompanyModal } from "./AddCompanyModal";
import { addCompany } from "../../Graphs/Company/addCompany";
import { alertError } from "../../utils/alert";

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyList: [],
      companyTotal: 0,
      isLoading: false,
      primaryColor: "#4466f2",
    };
  }

  async componentDidMount() {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setCompanyData,
        setCompanyToken,
        setListCompanyData,
        setListCompanyDataTotal,
        setRouteName,
        setSearchText,
      } = this.props;
      let editPrimaryColor = await localStorage.getItem("primary_color");
      console.log("!!!!!!!!editPrimaryColor", editPrimaryColor);

      await setRouteName("COMPANY");
      await setSearchText("");

      this.setState({
        isLoading: true,
        primaryColor: editPrimaryColor,
      });

      let companyData = await getAllCompany(authToken, 0, 10);
      console.log("TEST companyData.data:", companyData);
      if (companyData.status == 200) {
        //set user data
        await setListCompanyData(companyData.data);
        await setListCompanyDataTotal(companyData.total);
        console.log("companyData.data:", companyData.data);
        this.setState({
          companyList: companyData.data,
          companyTotal: companyData.total,
        });
      } else if (companyData.status == 401) {
        await setLoginFlag(false);
        await setCompanyData(null);
        await setCompanyToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        throw companyData && companyData.message
          ? companyData.message
          : "Error";
      }
    } catch (e) {
      alertError("Company", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  reloadData = async () => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setCompanyData,
        setCompanyToken,
        setListCompanyData,
        setListCompanyDataTotal,
        setRouteName,
        setSearchText,
      } = this.props;

      this.setState({
        isLoading: true,
      });

      let companyData = await getAllCompany(authToken, 0, 10);

      if (companyData.status == 200) {
        //set user data
        await setListCompanyData(companyData.data);
        await setListCompanyDataTotal(companyData.total);

        this.setState({
          companyList: companyData.data,
          companyTotal: companyData.total,
        });
      } else if (companyData.status == 401) {
        await setLoginFlag(false);
        await setCompanyData(null);
        await setCompanyToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        throw companyData && companyData.message
          ? companyData.message
          : "Error";
      }
    } catch (e) {
      alertError("Company", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  generateCsv = async () => {
    try {
      const { authToken } = this.props;
      this.setState(
        {
          isLoading: true,
        },
        () => {
          getAllCompany(authToken, 0, 1000000)
            .then((res) => {
              let csvArray = [];

              // csvArray.push();

              // res.data.map((data) => {
              //     csvArray.push([
              //         data.first_name ? data.first_name : "NA",
              //         data.email ? data.email : "NA",
              //         data.phone ? data.phone : "NA",
              //         data.username ? data.username : "NA",
              //         data.wallet_balance ? String(data.wallet_balance) : "NA",
              //     ]);
              // });

              const rows = res.data;
              let csvName = "AllCompanys.csv";
              let csvContent = "data:text/csv;charset=utf-8,";

              rows.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });

              var encodedUri = encodeURI(csvContent);
              // // // // window.open(encodedUri);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", csvName);
              document.body.appendChild(link); // Required for FF

              link.click();

              this.setState({
                isLoading: false,
              });
            })
            .catch((err) => {
              console.log("ERROR", err);
              throw err;
            });
        }
      );
    } catch (e) {
      console.log("error in generateCsv function", e);
    }
  };

  addSubmit = async (value) => {
    try {
      this.setState({
        isLoading: true,
      });

      let createObject = value;

      let coinData = await addCompany(this.props.authToken, createObject);

      if (coinData.status == 200) {
        this.setState({
          isLoading: true,
        });

        notification["success"]({
          message: "Company",
          description: "Successfully Added",
        });

        this.reloadData();

        return 1;
      } else {
        throw coinData.message ? coinData.message : "Error";
      }
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      alertError("Company", error);

      return -1;
    }
  };

  render() {
    const { authToken, loginCompanyData, loginUserData } = this.props;
    const { primaryColor, companyList, isLoading, companyTotal } = this.state;

    const accessPermission =
      (loginUserData.access_permission &&
        JSON.parse(loginUserData.access_permission)) ||
      false;

    console.log("accessPermission", accessPermission);

    return loginUserData.role !== "Admin" &&
      loginUserData.role !== "Company" &&
      // loginUserData.role !== "Employee" &&
      (!accessPermission ||
        !accessPermission["company"] ||
        accessPermission["company"].view == false) ? (
      <Fragment>
        <h5 style={{ marginTop: "30%", marginLeft: "30%" }}>
          You are not authorized for view this page.
        </h5>
      </Fragment>
    ) : (
      <Fragment>
        <Title parent="Company" title="company" />
        <div
          style={{
            marginTop: "20px",
            display: "inline-block",
            width: "100%",
            marginBottom: "20px",
            paddingLeft: "14px",
            paddingRight: "55px",
          }}
        >
          {/* <div onClick={() => this.generateCsv()} style={{float : "left", cursor : "pointer"}}>
                                <div style={{width : "100px", backgroundColor : primaryColor, color : "white", padding : "7px 0px", textAlign : "center", borderRadius : "50px"}}>
                                    Export Csv
                                </div>
                            </div> */}
          <div style={{ float: "right", cursor: "pointer", width: "100%" }}>
            <AddCompanyModal
              authToken={authToken}
              // reloadData={this.reloadData}
              onSubmit={this.addSubmit}
              primaryColor={this.state.primaryColor}
            />
          </div>
        </div>
        <div className="container-fluid">
          {isLoading ? (
            <div style={{ marginLeft: "20px" }}>
              <Spin
                size="large"
                style={{ marginLeft: "480px", marginTop: "130px" }}
              />
            </div>
          ) : (
            <div>
              <CompanyRecordsTable
                loginCompanyData={loginCompanyData}
                data={companyList}
                primaryColor={primaryColor}
                companyTotal={companyTotal}
              />
            </div>
          )}

          {/* <AddCompanyModal
                            admin={false}
                            authToken={this.props.authToken}
                            refx={(e) => (this.modalCompanyCoinsRef = e)}
                            onClose=""//{this.handleDetailsModalclose.bind(this)}
                            onSubmit=""//{this.editSubmit}
                        /> */}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginCompanyData: state.auth.loginCompanyData,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setCompanyData: (companyData) => {
      dispatch({
        type: "SET_USER_DATA",
        companyData: companyData,
      });
    },
    setCompanyToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListCompanyData: (listCompanyData) => {
      console.log("setListCompanyData");
      dispatch({
        type: "SET_LIST_COMPANY_DATA",
        listCompanyData: listCompanyData,
      });
    },
    setListCompanyDataTotal: (listCompanyDataTotal) => {
      dispatch({
        type: "SET_LIST_COMPANY_DATA_TOTAL",
        listCompanyDataTotal: listCompanyDataTotal,
      });
    },
    setRouteName: (routeName) => {
      dispatch({
        type: "SET_ROUTE_NAME",
        routeName: routeName,
      });
    },
    setSearchText: (searchText) => {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: searchText,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Company));
